// extracted by mini-css-extract-plugin
export var autoPromo = "howInstallmentWorks-module--autoPromo--84-qR";
export var backtoschool = "howInstallmentWorks-module--backtoschool--BFoVc";
export var bestBenefits = "howInstallmentWorks-module--bestBenefits--RibFX";
export var blackFriday = "howInstallmentWorks-module--blackFriday--7y7cK";
export var blackFriday2025 = "howInstallmentWorks-module--blackFriday2025--+cefF";
export var blackFridayHalva = "howInstallmentWorks-module--blackFridayHalva--N1iIe";
export var blackFridayHalvaMedia = "howInstallmentWorks-module--blackFridayHalvaMedia--4AKjx";
export var blackLink = "howInstallmentWorks-module--blackLink--Qhnga";
export var bonus1500 = "howInstallmentWorks-module--bonus1500--KROYj";
export var br = "howInstallmentWorks-module--br--BO2Jd";
export var br1 = "howInstallmentWorks-module--br1--6901j";
export var br3 = "howInstallmentWorks-module--br3--WZMHQ";
export var br32 = "howInstallmentWorks-module--br32--5UbYx";
export var brNoDesk = "howInstallmentWorks-module--brNoDesk--SYhKj";
export var btsAuto = "howInstallmentWorks-module--btsAuto--OOUVE";
export var cashback100 = "howInstallmentWorks-module--cashback100--RzqFR";
export var cashbeck20 = "howInstallmentWorks-module--cashbeck20--kp3Xo";
export var cashbeck2000 = "howInstallmentWorks-module--cashbeck2000--LKNoe";
export var cashbeck30 = "howInstallmentWorks-module--cashbeck30--FEHnc";
export var cbPromo = "howInstallmentWorks-module--cbPromo--5rB7-";
export var close = "howInstallmentWorks-module--close--kaNDr";
export var container = "howInstallmentWorks-module--container--Z-6-P";
export var genderAction = "howInstallmentWorks-module--genderAction--7Nw6P";
export var genderActionMedia = "howInstallmentWorks-module--genderActionMedia--xyh9d";
export var gethalvaBTS = "howInstallmentWorks-module--gethalvaBTS--AuM49";
export var halva = "howInstallmentWorks-module--halva--y2Ws4";
export var hintModal = "howInstallmentWorks-module--hintModal--6Iada";
export var hippo = "howInstallmentWorks-module--hippo--GuffT";
export var hippoparking = "howInstallmentWorks-module--hippoparking--97N2I";
export var kiberponedelnik = "howInstallmentWorks-module--kiberponedelnik--3Sd3r";
export var lenta = "howInstallmentWorks-module--lenta--566yW";
export var link = "howInstallmentWorks-module--link--pXShy";
export var linkBlack = "howInstallmentWorks-module--linkBlack--pbt07";
export var mayTrudHalva = "howInstallmentWorks-module--mayTrudHalva--K7f5c";
export var media = "howInstallmentWorks-module--media---yek7";
export var mesyacaBezProcentov = "howInstallmentWorks-module--mesyacaBezProcentov--08vRX";
export var nedeliUmnuxRassrochek = "howInstallmentWorks-module--nedeliUmnuxRassrochek--ifwZm";
export var nedeliUmnuxRassrochekMedia = "howInstallmentWorks-module--nedeliUmnuxRassrochekMedia--pIr7A";
export var newYear = "howInstallmentWorks-module--newYear--9ej3+";
export var newYearHalva = "howInstallmentWorks-module--newYearHalva--dgu0g";
export var newYearMedia = "howInstallmentWorks-module--newYearMedia--NYhx4";
export var pkw = "howInstallmentWorks-module--pkw---OglR";
export var pkwAviasales = "howInstallmentWorks-module--pkwAviasales--6nx61";
export var pkwOther = "howInstallmentWorks-module--pkwOther--i9hYS";
export var pkwOzon = "howInstallmentWorks-module--pkwOzon--IvePH";
export var pkwRedesign = "howInstallmentWorks-module--pkwRedesign--xA5fA";
export var pkwRefin = "howInstallmentWorks-module--pkwRefin--G2E8Q";
export var pointer = "howInstallmentWorks-module--pointer--Q1iwt";
export var procentyVernetMagazin = "howInstallmentWorks-module--procentyVernetMagazin--VUBEv";
export var productsCategories = "howInstallmentWorks-module--productsCategories--TcSZf";
export var promopage = "howInstallmentWorks-module--promopage--lKwzK";
export var rassrochkaSHalvoi = "howInstallmentWorks-module--rassrochkaSHalvoi--E73pA";
export var redLink = "howInstallmentWorks-module--redLink--SbX1D";
export var redisignBezProcentov = "howInstallmentWorks-module--redisignBezProcentov--M+0km";
export var refin = "howInstallmentWorks-module--refin---C+s9";
export var refinKreditnoyKarty = "howInstallmentWorks-module--refinKreditnoyKarty--hMzeC";
export var refinZadolzhennostej = "howInstallmentWorks-module--refinZadolzhennostej--6Ygpp";
export var schoolAction = "howInstallmentWorks-module--schoolAction--lQI0Z";
export var section = "howInstallmentWorks-module--section--jA5PJ";
export var shapka = "howInstallmentWorks-module--shapka--xAG0l";
export var shuba = "howInstallmentWorks-module--shuba--tK2Zs";
export var smartWeeks = "howInstallmentWorks-module--smartWeeks--icqkV";
export var standard = "howInstallmentWorks-module--standard--fP5h6";
export var step = "howInstallmentWorks-module--step--8WjEi";
export var stepSubtitle = "howInstallmentWorks-module--stepSubtitle--B+JNJ";
export var stepText = "howInstallmentWorks-module--stepText--3SdE8";
export var stepTitle = "howInstallmentWorks-module--stepTitle--kdxW5";
export var steps = "howInstallmentWorks-module--steps--cV6L8";
export var stickerPay = "howInstallmentWorks-module--stickerPay--SAVAj";
export var title = "howInstallmentWorks-module--title--pDMpK";
export var toolTipDashed = "howInstallmentWorks-module--toolTipDashed--m4lVt";
export var tooltip = "howInstallmentWorks-module--tooltip--GjMLc";
export var vkEducation = "howInstallmentWorks-module--vkEducation--K6Sr2";
export var wrapper = "howInstallmentWorks-module--wrapper--Qv1lh";
export var zoon = "howInstallmentWorks-module--zoon--R-FIP";